module.exports = __webpack_public_path__ + "img/whiteAdd.bd1b2182.svg";